import styles from './About.module.css';

function About() {
    return (
        <article className={styles.block} id='about'>
            <div className={styles.infoBlock}>
                <h3 className={styles.title}>Обо мне</h3>
                <p className={styles.text}>Меня зовут Мария. Я родилась в Москве в 1975 году. Окончила медицинский вуз, работаю врачом с 2001 года, кандидат медицинских наук. В детстве училась в музыкальной школе, играла на балалайке. Художественного образования не имею.</p>
            </div>
            <div className={styles.infoBlock}>
                <h3 className={styles.title}>Как я пришла к искусству?</h3>
                <p className={styles.text}>2022 год — постковидное время, напряжённое и непростое. Желание рисовать появилось само собой, как способ внутреннего диалога и осмысления. Живопись стала для меня личной терапией: погружение в себя, поиск цвета, работа с холстом — это время наедине с собой.</p>
            </div>
            <div className={styles.infoBlock}>
                <h3 className={styles.title}>Для кого моё творчество?</h3>
                <p className={styles.text}>В первую очередь — для меня. Со временем я начала делиться своими работами с семьёй, коллегами, пациентами. Создала <a href='https://t.me/osipovsart' target='_blank'>Telegram-канал</a>, и для многих мой новый образ стал открытием. Я увидела в их реакции живой интерес, вдохновение, желание меняться.</p>
            </div>
            <div className={styles.infoBlock}>
                <h3 className={styles.title}>О чём мои картины?</h3>
                <p className={styles.text}>О свободе самовыражения. О том, что не нужно бояться пробовать. Что даже без профессионального образования можно заниматься творчеством и получать удовольствие.</p>
            </div>
        </article>
    );
}

export default About;
